import MetaTags from "react-meta-tags";
import React, { useState, useEffect } from "react"
import { Row, Col, CardBody, Card, Container } from "reactstrap";
import banner from "../../assets/images/banner/banner.jpg";
import { useHistory } from "react-router-dom";

const success = () => {
    const history = useHistory();
    const [referenceNo, setReferenceNo] = useState('');

    function GoToLogin() {
        history.push("/login");
    }

    const cardBackground = {
        borderRadius: 15,
        flex: 1,
        marginTop: "20px",
        boxShadow: "#504f4f6b 5px 5px 20px",
        marginLeft: "150px",
        marginRight: "150px"
    }

    useEffect(() => {
        setReferenceNo(localStorage.getItem("ReferenceNo"));
        localStorage.clear();
    }, []);

    return (
        <React.Fragment>
            <MetaTags>
                <title>JSB-Success</title>
            </MetaTags>
            <div className="account-pages my-5 pt-sm-5">
                <Container fluid={true}>
                    <Row className="justify-content-center">
                        <Col lg="6">
                            <Card className="overflow-hidden" style={ cardBackground }>
                                <div className="navbar-header">
                                    <div style={{ width: "110%", backgroundColor: "#9a084f" }}>
                                        <div>
                                            <img className="img-fluid" style={{ height: "80px", maxWidth: "103%", height: "auto" }} src={banner} alt="Banner" />
                                        </div>
                                    </div>
                                </div><br></br><br></br>
                                <CardBody className="pt-0">
                                    <div style={{ textAlign: "center", fontSize: "x-large", fontWeight: "bold", height: "250px" }}>
                                        <label className="mdi mdi-check-circle-outline text-success display-4"></label>
                                        <label style={{ fontSize: "18px" }}> Your form has been submitted successfully!</label>
                                        <label style={{ fontSize: "17px" }}> Reference No. : </label>
                                        <label style={{ fontWeight: "bold", marginLeft: "10px", fontSize: "17px" }}>{referenceNo}</label><br />
                                        <label style={{ fontSize: "18px" }}>Go to <a style={{ color: "blue" }} onClick={GoToLogin}>Login</a></label>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <footer style={{ backgroundColor: "#333333", color: "white", height: "50px", position: "absolute", bottom: "0" }}>
                            <Container fluid={true}>
                                <Row>
                                    <Col style={{ marginTop: "15px" }} md={6}> &copy; 2022 all rights reserved</Col>
                                    <Col style={{ marginTop: "15px" }} md={6}>
                                        <div className="text-sm-end d-none d-sm-block">
                                            Powered by ZingWorks LLP
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </footer>
                    </Row>
                </Container>
            </div >
        </React.Fragment >
    );
};

export default success


